/* eslint-disable no-undef */
/* eslint-disable no-script-url */

var captcha;
function generateRandomString(length) {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
const CONFIG = {
  prefix: 'wo6c8d',      // 身份标
  sceneId: '1cc2q0zm',   // 场景ID
  region: 'cn',          // 地域：cn(中国内地) / sgp(新加坡)
  mode: 'popup',         // 验证码模式：popup(弹出式) / embed(嵌入式)
  element: '#captcha-element',
  button: '#captcha-trigger-btn' // 使用隐藏的触发按钮
};
export const dataInit = () => {
  window.AliyunCaptchaConfig = {
    region: CONFIG.region,
    prefix: CONFIG.prefix,
  };
};

export const importGuide = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = `//o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js`;
  document.head.appendChild(script);

  // 验证码容器
  if (!document.getElementById('captcha-element')) {
    const div = document.createElement('div');
    div.id = 'captcha-element';
    document.body.appendChild(div);
  }
};


/**
 * 创建验证码实例（页面加载时调用一次）
 */
export const createCaptchaInstance = () => {
  return new Promise((resolve, reject) => {
    // 如果已经创建过实例，直接返回

    captcha = null;

    // 等待 SDK 加载完成
    const checkSDK = () => {
      if (typeof window.initAliyunCaptcha !== 'function') {
        setTimeout(checkSDK, 100);
        return;
      }

      console.log('[AliyunCaptcha] 开始创建实例');
      window.initAliyunCaptcha({
        SceneId: CONFIG.sceneId,
        mode: CONFIG.mode,
        element: CONFIG.element,
        button: CONFIG.button,
        language: 'cn',
        // UserCertifyId: `${CONFIG.prefix}_${generateRandomString(10)}`,
        success: async (captchaVerifyParam) => {
          console.log('[AliyunCaptcha] 验证通过', captchaVerifyParam);
          // 触发自定义事件，通知验证通过
          window.dispatchEvent(new CustomEvent('aliyun-captcha-success', { 
            detail: captchaVerifyParam 
          }));
          createCaptchaInstance();
        },
        fail: (failResult) => {
          // createCaptchaInstance(); // 失败后不需要重新实例化，sdk会自动刷新实例
          console.error('[AliyunCaptcha] 验证失败', failResult);
        },
        getInstance: (instance) => {
          captcha = instance;
          console.log('[AliyunCaptcha] 实例创建成功');
          resolve(instance);
        }
      });
    };

    checkSDK();
  });
};

/**
 * 启动验证码（点击登录按钮时调用）
 */
export const startCaptcha = () => {
  return new Promise((resolve, reject) => {
    if (!captcha) {
      reject(new Error('验证码实例未创建'));
      return;
    }

    // 监听验证成功事件
    const handleSuccess = (event) => {
      window.removeEventListener('aliyun-captcha-success', handleSuccess);
      resolve(event.detail);
    };
    window.addEventListener('aliyun-captcha-success', handleSuccess);
  });
};

